import React, { useRef, useState } from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  CircularProgress
} from '@mui/material';

const PrintDialog = ({ successDialog, setSuccessDialog }) => {
  const printRef = useRef();
  const [isPrinting, setIsPrinting] = useState(false);

  // Extract transaction data from successDialog with proper nesting
const transactionData = successDialog.data|| {};
const verificationData = transactionData?.details|| {};
const tokens = transactionData?.cards || [];
console.log('res',tokens);

  const handlePrint = () => {
    setIsPrinting(true);

    const printWindow = window.open('', '_blank');

    const printStyles = `
      <style>
        body {
          font-family: Arial, sans-serif;
          line-height: 1.5;
          color: #000;
          padding: 20px;
          max-width: 800px;
          margin: 0 auto;
        }
        .receipt-container {
          border: 1px solid #ddd;
          padding: 20px;
          border-radius: 4px;
        }
        .receipt-header {
          font-size: 24px;
          font-weight: bold;
          margin-bottom: 20px;
          text-align: center;
          border-bottom: 2px solid #000;
          padding-bottom: 10px;
        }
        .receipt-section {
          margin: 15px 0;
        }
        .receipt-section-title {
          font-weight: bold;
          font-size: 18px;
          margin-bottom: 10px;
          border-bottom: 1px solid #eee;
          padding-bottom: 5px;
        }
        .receipt-item {
          margin: 8px 0;
          display: flex;
        }
        .receipt-item-label {
          font-weight: bold;
          min-width: 180px;
        }
        .receipt-item-value {
          flex-grow: 1;
          word-break: break-all;
        }
        @media print {
          body {
            padding: 0;
          }
        }
      </style>
    `;

    printWindow.document.write(`
      <html>
        <head>
          <title>Transaction Receipt</title>
          ${printStyles}
        </head>
        <body>
          <div class="receipt-container">
            <div class="receipt-header"><img src="/logo.png" width="200"/> Transaction Receipt</div>

            <div class="receipt-section">
              <div class="receipt-section-title">Transaction Summary</div>
              <div class="receipt-item">
                <div class="receipt-item-label">Date:</div>
                <div class="receipt-item-value">${new Date().toLocaleString()}</div>
              </div>
              <div class="receipt-item">
                <div class="receipt-item-label">Status:</div>
                <div class="receipt-item-value">Completed</div>
              </div>
              <div class="receipt-item">
                <div class="receipt-item-label">Reference:</div>
                <div class="receipt-item-value">${verificationData.requestId || '—'}</div>
              </div>
            </div>

            <div class="receipt-section">
              <div class="receipt-section-title">Payment Details</div>
              <div class="receipt-item">
                <div class="receipt-item-label">Product Name:</div>
                <div class="receipt-item-value">${verificationData.product_name || '—'}</div>
              </div>
              <div class="receipt-item">
                <div class="receipt-item-label">Amount:</div>
                <div class="receipt-item-value">${verificationData.amount || '—'}</div>
              </div>
              <div class="receipt-item">
                <div class="receipt-item-label">Transaction ID:</div>
                <div class="receipt-item-value">${verificationData.transactionId || '—'}</div>
              </div>

            </div>

            <div class="receipt-section">
              <div class="receipt-section-title">Token Details</div>
              <div class="receipt-item">
                <div class="receipt-item-label">Purchased Code:</div>
                <div class="receipt-item-value">${verificationData.purchased_code || '—'}</div>
              </div>
              ${tokens.length > 0 ? `
                 <div style="display: flex; flex-direction: column; margin-bottom: 1rem;">
                    <div style="font-weight: bold;">Tokens:</div>
                    ${tokens.map((token, index) => `
                        <div key="${index}">
                        Serial: ${token.Serial}, Pin: ${token.Pin}
                        </div>
                    `).join('')}
                    </div>
              ` : ''}

            </div>
          </div>
          <script>
            setTimeout(() => {
              window.print();
              window.onafterprint = function() {
                window.close();
              };
            }, 500);
          </script>
        </body>
      </html>
    `);

    printWindow.document.close();
    setIsPrinting(false);
  };

  return (
    <Dialog open={successDialog.open} maxWidth="md" fullWidth>
      <DialogTitle><img src="/logo.png" width="200"/>Transaction Successful</DialogTitle>
      <DialogContent ref={printRef} dividers>
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" gutterBottom>Transaction Summary</Typography>
          <Box sx={{ display: 'flex', mb: 1 }}>
            <Typography sx={{ minWidth: 180, fontWeight: 'bold' }}>Date:</Typography>
            <Typography>{new Date().toLocaleString()}</Typography>
          </Box>
          <Box sx={{ display: 'flex', mb: 1 }}>
            <Typography sx={{ minWidth: 180, fontWeight: 'bold' }}>Status:</Typography>
            <Typography color="success.main">Completed</Typography>
          </Box>
          <Box sx={{ display: 'flex', mb: 1 }}>
            <Typography sx={{ minWidth: 180, fontWeight: 'bold' }}>Reference:</Typography>
            <Typography>{verificationData.requestId || '—'}</Typography>
          </Box>
        </Box>

        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" gutterBottom>Payment Details</Typography>
          <Box sx={{ display: 'flex', mb: 1 }}>
            <Typography sx={{ minWidth: 180, fontWeight: 'bold' }}>Product Name:</Typography>
            <Typography>{verificationData.product_name || '—'}</Typography>
          </Box>
          <Box sx={{ display: 'flex', mb: 1 }}>
            <Typography sx={{ minWidth: 180, fontWeight: 'bold' }}>Amount:</Typography>
            <Typography>{verificationData.amount || '—'}</Typography>
          </Box>
          <Box sx={{ display: 'flex', mb: 1 }}>
            <Typography sx={{ minWidth: 180, fontWeight: 'bold' }}>Transaction ID:</Typography>
            <Typography>{verificationData.transactionId || '—'}</Typography>
          </Box>

        </Box>

        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" gutterBottom>Token Details</Typography>
          <Box sx={{ display: 'flex', mb: 1 }}>
            <Typography sx={{ minWidth: 180, fontWeight: 'bold' }}>Purchased Code:</Typography>
            <Typography>{verificationData.purchased_code || '—'}</Typography>
          </Box>
          {tokens.length > 0 && (
            <Box sx={{ display: 'flex', mb: 1, flexDirection: 'column' }}>
                <Typography sx={{ fontWeight: 'bold' }}>Tokens:</Typography>
                {tokens.map((token, index) => (
                <Typography key={index}>
                    Serial: {token.Serial}, Pin: {token.Pin}
                </Typography>
                ))}
            </Box>
            )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handlePrint}
          disabled={isPrinting}
          startIcon={isPrinting ? <CircularProgress size={20} /> : null}
          variant="contained"
          color="primary"
        >
          {isPrinting ? 'Generating Receipt...' : 'Print Receipt'}
        </Button>
        <Button
          onClick={() => setSuccessDialog({ ...successDialog, open: false })}
          disabled={isPrinting}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PrintDialog;